import { EXPORT_TO_CSV_ENDPOINT } from 'api/ListsApi';
import { postFormToEndpoint } from '../utils';
import { useListId } from './useListId';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';
import { CSVPostFormParams } from '../types';

export const useExportToCSV = (fields: CSVPostFormParams['fields']) => {
  const listId = useListId();
  const { searchQuery } = useSegmentationQueryContext();
  const params = {
    searchQuery,
    fields,
    ...(listId && { emailListId: listId.toString() }),
  };

  return () => postFormToEndpoint(EXPORT_TO_CSV_ENDPOINT, params);
};
